var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddChild(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_55)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0589 15.4002C23.1369 15.4002 24.8574 17.0485 24.8574 19.1266C24.8574 21.2767 23.1378 22.9251 21.0589 22.9251C18.9809 22.9251 17.2604 21.2768 17.2604 19.1266C17.2604 17.0486 18.98 15.4002 21.0589 15.4002ZM21.6321 20.9895C21.6321 21.7062 20.4857 21.7062 20.4857 20.9895V19.7709H19.1958C18.4791 19.7709 18.4791 18.5523 19.1958 18.5523H20.4857V17.3337C20.4857 16.5457 21.6321 16.5457 21.6321 17.3337V18.5523H22.8507C23.6388 18.5523 23.6388 19.7709 22.8507 19.7709H21.6321V20.9895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1046 2.14352C14.251 2.00001 15.3974 2.78805 15.5409 3.7918C17.6188 3.86313 17.6188 6.87357 16.9743 8.52181C18.6226 8.30696 17.4762 12.0332 16.5446 11.9619C16.3298 13.1083 15.8279 14.1121 15.1112 14.8288V15.9038C15.8279 15.9752 16.5446 16.1909 17.2613 16.4057C16.6881 17.1937 16.3298 18.1253 16.3298 19.1291C16.3298 20.6338 16.9743 21.8525 17.9781 22.7839C16.2585 23.572 14.3954 24.0026 12.3166 24.0026C8.73388 24.0026 5.50868 22.5691 3.14368 20.2762C3.35852 19.4159 3.71689 18.3417 4.57711 17.6962C5.93836 16.7647 7.73015 16.1915 9.59333 15.9045V14.8294C8.87661 14.1127 8.37473 13.1098 8.1599 11.9626C7.22833 12.0339 6.15325 8.37986 7.65803 8.52242C6.79779 6.58796 7.58671 3.93586 9.09147 3.00438C7.94507 1.14124 8.80443 2.50252 13.1047 2.14414L13.1046 2.14352Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddChild);
export default __webpack_public_path__ + "static/media/add_child.0303512691f5efb0d1432c0750362cb9.svg";
export { ForwardRef as ReactComponent };